import { render, staticRenderFns } from "./jobfair_online.vue?vue&type=template&id=5c5daaef&scoped=true"
import script from "./jobfair_online.vue?vue&type=script&lang=js"
export * from "./jobfair_online.vue?vue&type=script&lang=js"
import style0 from "./jobfair_online.vue?vue&type=style&index=0&id=5c5daaef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5daaef",
  null
  
)

export default component.exports